(ns practitest.frontend.components.toolbar
  (:require [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.tooltip :as tooltip]
            [practitest.frontend.components2.dropdown :as dropdown]))

(defn base-toolbar-button
  [{:keys [icon title toggled? class disabled?]
    :as options}]
  [tooltip/mux-tooltip
   {}
   title
   (fn [props]
     [:button
      (merge
        props

        {:tab-index -1
         :class (dom/append-class (dom/classes-pairs-v
                                    "disabled" disabled?
                                    "m3-memo-button" true
                                    "active" toggled?)
                                  class)
         :type "button"

         :disabled disabled?

         ;; Prevent toolbar buttons from grabbing focus
         :on-mouse-down dom/prevent-default}

        (dissoc options :title :toggled? :class :icon :disabled?))
      icon])])

(defn toolbar-overflow-menu
  "Overflow menu for markdown toolbar - converts toolbar buttons to dropdown items"
  [button-components]
  (let [close-fn (atom nil)]
    [:div.m3-toolbar-overflow-menu
     [dropdown/dropdown-menu
      (fn [{:keys [toggle!]}]
        (reset! close-fn toggle!)
        [base-toolbar-button
         {:title (get-translation "markdown.toolbar.more-options" "More options")
          :on-click (fn [e]
                      (dom/prevent-default e)
                      (toggle!))
          :icon [icons/mux-three-dots]}])
      {:placement "bottom-start"
       :flip true}
      (into [dropdown/dropdown-menu-body {}]
            (for [component button-components]
              ;; Convert base-toolbar-button to dropdown-menu-item
              (when (and (vector? component)
                         (= (first component) base-toolbar-button))
                (let [props (second component)
                      {:keys [title dropdown-text icon on-click disabled?]} props]
                  [dropdown/dropdown-menu-item
                   {:text (or dropdown-text title)
                    :icon icon
                    :disabled? disabled?
                    :tooltip (when disabled? title)
                    :on-click (fn [e]
                                (when on-click (on-click e))
                                (when @close-fn (@close-fn)))}]))))]]))